import React from 'react';

import styled from '@emotion/styled';

import Typography from 'components/base/Typography';

// Styled Components
export const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  padding: 20px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
`;

export const SuccessTitle = styled(Typography)`
  font-family: 'Canva Sans', sans-serif !important;
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  margin-bottom: 16px;
`;

export const ErrorMessage = styled.p`
  font-family: 'Canva Sans', sans-serif !important;
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;
  text-align: center;
  margin-bottom: 12px;
`;

export const HelpText = styled.p`
  font-family: 'Canva Sans', sans-serif !important;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  margin-bottom: 12px;
  color: #87909ab2;
`;

export const LoadingText = styled(Typography)`
  font-family: 'Canva Sans', sans-serif !important;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  margin-top: 16px;
`;

export const Spinner = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid #69ba92;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const LookupImage = styled.img`
  height: 90px;
  margin-bottom: 10px;
`;
export const RocketImage = styled.img`
  height: 90px;
  margin-bottom: 10px;
`;
